export default {
	Menu: {
		DASHBOARD: 'Tổng quan',
		OVERVIEWDASHBOARD: 'Tổng quan hệ thống',
		PROCCESS: 'Quy trình nghiệp vụ',
		AVADASHBOARD: 'Trợ thủ AI - MISA AVA',
		INSTRUCTIONS: "Hướng dẫn sử dụng",
		INVOICE: 'Hóa đơn đầu vào',
		INVOICELIST: 'Danh sách hóa đơn',
		TRASHINVOICE: 'Hóa đơn đã xóa',
		Received: 'Hóa đơn đầu vào',
		// PBI-547654: Bank Audit - Conditional Labels
		INVOICETHIRDPARTY: 'Hóa đơn',
		INBOX: 'Hộp thư',
		SUPPLIER: 'Danh mục',
		OrganizationStructure: 'Cơ cấu tổ chức',
		USER: 'Phân quyền sử dụng',
		Resource: 'Quản lý tài nguyên',
		SPAMINBOX: 'Thư rác',
		TRASHBOX: "Thùng rác",
		IMPORTANTINBOX: 'Thư quan trọng',
		INBOXTO: 'Hộp thư đến',
		AuditingLog: 'Nhật ký truy cập',
		System: 'Hệ thống',
		ConnectInvoices: 'Kết nối nhà cung cấp',
		ConnectTaxaxions: 'Kết nối Cơ quan thuế',
		OutInvoice: 'Hóa đơn đầu ra',
		Report: 'Báo cáo',
		ManageUser: 'Quản lý người dùng',
		UserSetup: "Thiết lập người dùng",
		ManageRole: 'Vai trò quyền hạn',
		ManageResource: 'Quản lý tài nguyên',
		DiaryLogs: 'Nhật ký truy cập',
		HistoryVatRate: 'Lịch sử chấp nhận thuế suất',
		Options: 'Tùy chọn',
		ConnectSupplier: 'Nhà cung cấp',
		Connected: 'Đã kết nối',
		ReportInvoiceRiskSupplier: 'Báo cáo hóa đơn rủi ro theo nhà cung cấp',
		ReportInvoiceBySupplierActive: 'Báo cáo hóa đơn theo tình trạng hoạt động của nhà cung cấp',
		CustomsDeclaration: 'Tờ khai hải quan',
		CustomsDeclarationTrash: 'Tờ khai đã xóa',
		CatalogSupplier: 'Nhà cung cấp/Khách hàng',
		CatalogVatRate: 'Lịch sử thuế suất hàng hóa',
		KnowledgeBase: 'Kiến thức hữu ích'
	}
};
